// 공개 링크 — 링크마다 `/s/p/{code}` · 레이아웃(A 그리드 · B 이야기) · 대표 사례. 지우지 않고 끄기만 한다(`0049`).

export const PUBLIC_PAGE_LAYOUTS = ["GRID", "STORY"] as const;
export type PublicPageLayout = (typeof PUBLIC_PAGE_LAYOUTS)[number];

export const PUBLIC_PAGE_LAYOUT_LABEL: Record<PublicPageLayout, string> = {
  GRID: "A 그리드",
  STORY: "B 이야기",
};

// 조직당 켜 둔 링크 수 · B 대표 사례 수 · 이름 길이(`0049` check 와 같다).
export const MAX_ACTIVE_PUBLIC_PAGES = 20;
export const MAX_FEATURED_PORTFOLIOS = 6;
export const MAX_PUBLIC_PAGE_NAME = 40;

export interface PublicPage {
  id: string;
  org_id: string;
  code: string;
  name: string;
  layout: PublicPageLayout;
  active: boolean;
  hero_portfolio_id: string | null;
  featured_ids: string[];
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

// 만들기·고치기가 받는 칸 — normalizePublicPageInput 을 거친 값이다.
export interface PublicPageInput {
  name: string;
  layout: PublicPageLayout;
  hero_portfolio_id: string | null;
  featured_ids: string[];
}

// 새 행 — id·code 는 앱이 만든다.
export interface PublicPageCreate extends PublicPageInput {
  id: string;
  code: string;
  created_by: string | null;
}

// 로그인 없는 경로가 읽는 열만 — 이름·작성자는 나가지 않는다(B 사례 목록은 서버가 공개 사례로 거른 뒤에만 쓴다).
export type PublicPageLinkRow = Pick<PublicPage, "id" | "org_id" | "code" | "layout" | "hero_portfolio_id" | "featured_ids">;
